import Store from 'store'

export default {
  data () {
    return {
      gateFormSlug: '',
      gateFormCTA: null,
      gateFormFilled: false
    }
  },
  computed: {
    shouldShowGateForm () {
      return !(this.isSelf || this.gateFormFilled || !this.gateFormCTA)
    },
    gateFormStoreKey () {
      return `gate-form-submitted:${this.gateFormSlug}`
    },
    isSelf () {
      return false
    }
  },

  methods: {
    initGateFormCTA (slug, callToActions) {
      this.gateFormSlug = slug
      this.gateFormCTA = callToActions.find(
        cta => cta.type === this.constants.App_Models_CallToAction.TYPE_FORM && cta.data.form_gate_video
      )

      this.gateFormFilled = Store.get(this.gateFormStoreKey) === '1'
    },

    submittedGateForm () {
      this.gateFormFilled = true
      this.gateFormCTA.show_button = false

      Store.set(this.gateFormStoreKey, '1')
    },

    showGateForm () {
      this.$refs.formCta.open()
    }
  }
}
